"use strict";
import { Text } from "ui/src";
import { iconSizes } from "ui/src/theme";
import { WalletBaseOptionItem } from "components/lists/items/wallets/WalletBaseOptionItem";
import { AccountIcon } from "features/accounts/AccountIcon";
import { useAvatar } from "features/address/avatar";
import { UnitagName } from "features/unitags/UnitagName";
import { sanitizeAddressText } from "utils/addresses";
import { shortenAddress } from "utilities/src/addresses";
export function UnitagOptionItem({ unitagOption, onPress }) {
  const { address, unitag } = unitagOption;
  const { avatar } = useAvatar(address);
  return <WalletBaseOptionItem
    option={unitagOption}
    image={<AccountIcon address={address} avatarUri={avatar} size={iconSizes.icon40} />}
    title={<UnitagName
      displayUnitagSuffix
      displayIconInline
      name={unitag}
      textProps={{ variant: "body1", lineHeight: void 0 }}
    />}
    subtitle={<Text color="$neutral2" variant="body2">
          {sanitizeAddressText(shortenAddress(address))}
        </Text>}
    onPress={onPress}
  />;
}
